import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CardTabsLinkStack = styled(Stack)(({ theme }) => ({
  background: theme?.customColors?.backgroundCard,
  border: `2px solid ${theme.customColors.border}`,
  borderRadius: "1rem",
  cursor:"pointer",
  gap: theme.spacing(1), 
  // maxWidth: "unset",
  padding: "1rem 1.5rem",
  width:"100%",

  "&.not-allowed":{
    cursor:"not-allowed"
  },

  [theme.breakpoints.down("sm")]:{
    padding: "0.5rem 1rem"
  }
}));
          
